import { useTranslation } from 'react-i18next';

import StatusColorsBlock from './StatusColorsBlock';

import miceIcon from 'assets/images/encounter-icon/encounter_mouse.svg';
import cockroachIcon from 'assets/images/encounter-icon/encounter_cockroach.svg';
import { DevicesColors } from 'pages/InteractiveMap/customMarker/constants';

const EncountersTab = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h5>{t('MapLegend.EncountersTab.markerExamples')}</h5>
      <div className="d-flex gap-2 align-items-center mb-2 pb-2">
        <img src={miceIcon} width={45} height={45} alt="encounter icon" />
        <span className="ml-2 text-dark">{t('MapLegend.EncountersTab.pestSighting')}</span>
      </div>
      <div className="d-flex gap-2 align-items-center border-bottom mb-2 pb-2">
        <img src={cockroachIcon} width={45} height={45} alt="encounter icon" />
        <span className="ml-2 text-dark">{t('MapLegend.EncountersTab.cockroachSighting')}</span>
      </div>
      <div className="d-flex flex-column gap-2 px-3">
        <h5 className="text-center">{t('MapLegend.EncountersTab.statusColors')}</h5>
        <div className="d-flex flex-column gap-2">
          <StatusColorsBlock
            status={DevicesColors.danger}
            description={t('MapLegend.EncountersTab.needImmediateAction')}
          />
        </div>
      </div>
    </div>
  );
};

export default EncountersTab;
